<!-- TODO - if this component is ever needed again, replace ng-drag-drop and angular2-draggable usage usage with cdk drag drop -->

<!-------------------- SIDEBAR -------------------->
@if (isReady) {
<div id="sidebar" #rulesBody class="body" ngResizable rzHandles="e">
  <header>
    <div class="ui pointing secondary menu">
      <!-- <div class="item categories" (click)="activeTab = 'categories'" [ngClass]="{active: activeTab === 'categories'}">{{ 'settings.categories' | transloco }}</div> -->
      <!-- <div class="item sub-categories" (click)="activeTab = 'sub-categories'" [ngClass]="{active: activeTab === 'sub-categories'}">{{ 'settings.subcategories' | transloco }}</div> -->
      <!-- <div class="item subgroups" (click)="activeTab = 'subgroups'" [ngClass]="{active: activeTab === 'subgroups'}">{{ 'settings.subgroups' | transloco }}</div> -->
      <div
        class="item questions"
        (click)="activeTab = 'questions'"
        [ngClass]="{ active: activeTab === 'questions' }"
      >
        {{ "settings.questions" | transloco }}
      </div>
      <div
        class="item questions"
        (click)="activeTab = 'conditional logic'"
        [ngClass]="{ active: activeTab === 'conditional logic' }"
      >
        {{ "smartForms.CONDITIONAL-LOGIC" | transloco }}
      </div>
    </div>
  </header>
  <div
    class="ui tab questions tab-contents"
    [ngClass]="{ active: activeTab === 'questions' }"
  >
    <div class="header">
      <div class="search">
        <div class="ui left icon input">
          <i class="search icon"></i>
          <input
            id="question-search"
            type="text"
            [(ngModel)]="questionSearch"
            [placeholder]="'smartForms.Search-Questions' | transloco"
          />
        </div>
      </div>
      @if (!isProductionMode) {
      <a
        [routerLink]="['/settings', 'questions', 'new']"
        [queryParams]="getTaxYearParam()"
        target="_blank"
        class="ui primary button"
        >{{ "settings.create-new" | transloco }}</a
      >
      }
    </div>
    <div class="content hidden-scrollbar">
      @if (questions?.length > 0) {
      <div class="question-list">
        @for (question of (questions | keyWord:['question', 'id',
        'displayFieldType']:questionSearch:false:true); track question) {
        <div
          style="cursor: move;"
          draggable
          [dragScope]="'question'"
          [dragData]="generateDragData(question, false)"
          (mouseover)="onDragStart(question, false)"
          dragClass="dragging"
        >
          <div
            class="question flex"
            (click)="
              question.children
                ? (question.collapsed = !question.collapsed)
                : ''
            "
          >
            <div class="flex" style="align-items: start;">
              <div
                style="display: flex; flex-direction: column;"
                [style]="question.children ? 'cursor: pointer;' : ''"
              >
                @if (showQuestionId) {
                <b>{{ question.id }}.</b>
                } @if (question.children?.length) {
                <i
                  class="chevron icon"
                  style="cursor: pointer; font-size: larger;"
                  [ngClass]="{
                    up: question?.collapsed,
                    down: !question?.collapsed
                  }"
                ></i>
                }
              </div>
              <div>
                <b>{{question?.question ?? 'question'}}</b>
                <div>{{question?.category ?? 'category'}}</div>
              </div>
            </div>
            <div class="flex-right">
              {{question?.displayFieldType ?? 'Text'}}
            </div>
          </div>
          @for (childQuestion of question.collapsed ? question?.children : [];
          track childQuestion) {
          <div
            class="question flex"
            style="margin-bottom: 0.5rem; margin-top: 0.5rem; margin-left: 3rem; background-color: rgb(200, 200, 200);"
          >
            <div class="flex" style="align-items: start;">
              @if (showQuestionId) {
              <b>{{ childQuestion.id }}.</b>
              }
              <div>
                <b>{{childQuestion?.question ?? 'question'}}</b>
                <div>{{childQuestion?.category ?? 'category'}}</div>
              </div>
            </div>
            <div class="flex-right">
              {{childQuestion?.displayFieldType ?? 'Text'}}
            </div>
          </div>
          }
        </div>
        }
      </div>
      } @if (questions?.length === 0) {
      <div *ngTemplateOutlet="noResults; context: { type: 'question' }"></div>
      }
    </div>
  </div>
  <div
    class="ui tab tab-contents"
    [ngClass]="{ active: activeTab === 'conditional logic' }"
  >
    <div class="header">
      <div class="search">
        <div class="ui left icon input">
          <i class="search icon"></i>
          <input
            id="question-search"
            type="text"
            [(ngModel)]="questionSearch"
            placeholder="Search Conditions"
          />
        </div>
      </div>
      @if (!isProductionMode) {
      <a (click)="OpenConditionalLogic(null)" class="ui primary button">{{
        "settings.create-new" | transloco
      }}</a>
      }
    </div>
    <div class="content hidden-scrollbar">
      @for (rootCondition of rootLogicNodes; track rootCondition) {
      <div>
        @if (questionsInUse?.length) {
        <smartFormLogic-card
          [rootCondition]="rootCondition"
          [questions]="questionsInUse"
          (onClickEdit)="OpenConditionalLogic(rootCondition)"
        >
        </smartFormLogic-card>
        }
      </div>
      }
    </div>
  </div>
</div>
} @if (isReady) {
<div id="content" class="hidden-scrollbar">
  <div id="header">
    <div
      style="margin-top: 1em"
      [routerLink]="['/settings', 'smartForm', 'builder-year-select']"
      [routerLinkActive]="['active']"
    >
      <i class="angle double left icon"></i>
      {{ "smartForms.Smart-Form-Builder" | transloco }}
    </div>
    <div class="flex">
      <h1 style="margin: 0px;">
        {{ taxYear }} - {{originalSmartFormData?.name ?? 'smart form name'}}
      </h1>
      <div class="flex" style="gap: 0.5em;">
        <div class="count-circle flex">
          <div class="count">{{ countUsedQuestions() }}</div>
        </div>
        {{
          countUsedQuestions() != 1
            ? ("smartForms.questions" | transloco)
            : ("smartForms.question" | transloco)
        }}
      </div>
      @if (lockStatus) {
      <div class="locked-status">
        <span class="field-label ui label">
          {{ "smartForms.Locked" | transloco }}
        </span>
      </div>
      }
      <!-- <div style="margin-right:1em; display: inline-block;" class="flex-right ui primary">
        <div title="Show additional config information" class="flex">
          <input [formControl]="debugModeControl" type="checkbox">
          <label>{{ 'settings.debug' | transloco }}</label>
        </div>
      </div> -->
      <div
        (click)="syncCache()"
        class="ui primary button flex-right"
        style="color: white;"
        [ngClass]="{ loading: isSyncingCache }"
      >
        {{ "smartForms.SYNC-CACHE" | transloco }}
      </div>
      @if (canSyncToOneteam()) {
      <div
        class="ui basic blue button sync-to-oneteam"
        (click)="!syncingWithOneTeam && syncToOneteam()"
        [ngClass]="{ loading: syncingWithOneTeam }"
      >
        <img
          class="sync-to-oneteam-logo"
          alt="Oneteam Logo"
          src="../../assets/oneteam.png"
        />{{ "settings.Sync-Smart-Form-to-OneTeam" | transloco }}
      </div>
      } @if (!isProductionMode) {
      <div
        (click)="saveSmartFormDataToDatabase()"
        class="ui primary save button"
        style="color: white;"
        [ngClass]="{ loading: isSaving }"
      >
        {{ "smartForms.SAVE" | transloco }}
      </div>
      }
    </div>
    <div class="flex">
      <div class="category-count">
        {{categories?.length ?? 0}}
        {{(categories.length ?? 0) != 1 ? ('smartForms.categories' |  transloco) : ('smartForms.category' |  transloco) }}
      </div>
      @if (!isProductionMode) {
      <div class="ui button" (click)="showCreateCategoryModal()">
        <i class="plus circle icon"></i>
        {{ "smartForms.Add-Category" | transloco }}
      </div>
      }
      <div class="ui button flex-right" (click)="collapseAll()">
        {{ "smartForms.Collapse-All" | transloco }}
      </div>
      <div class="ui button" (click)="expandAll()">
        {{ "smartForms.Expand-All" | transloco }}
      </div>
    </div>
  </div>
  <!-------------------- BODY -------------------->
  <div id="body" #body>
    @for (category of categories; track category; let i = $index) {
    <div
      class="ui grid subgroup-card"
      [ngClass]="{ collapsed: category.collapsed }"
      [reOrderableList]="categories"
      (moveUp)="swapItemsInList(categories, i, i - 1)"
      (moveDown)="swapItemsInList(categories, i, i + 1)"
      ngDraggable
      [handle]="categoryDragHandle"
      [preventDefaultEvent]="true"
      [zIndexMoving]="9999"
      [trackPosition]="false"
      lockAxis="x"
      [bounds]="body"
      [inBounds]="false"
    >
      <div
        class="row card-header no-select flex"
        (click)="category.collapsed = !category.collapsed"
        [ngClass]="category.collapsed ? '' : 'open'"
      >
        <i
          class="chevron icon"
          [ngClass]="{ up: !category.collapsed, down: category.collapsed }"
        ></i>
        <h3>{{(category.id ?? ' ') + '. ' + category.name}}</h3>
        <div
          class="condition-count"
          (mouseenter)="category.hoverConditions = true"
          (mouseleave)="category.hoverConditions = false"
        >
          {{ category.conditionIds?.length || 0 }}
          {{
            category.conditionIds?.length != 1
              ? ("smartForms.conditions" | transloco)
              : ("smartForms.condition" | transloco)
          }}
          @if (category.hoverConditions && category.conditionIds?.length) {
          <div class="popup-content" style="left: 175%">
            @for (conditionId of category.conditionIds; track conditionId; let
            first = $first) {
            <div>
              @if (!first) {
              <hr />
              } @if (questionsInUse?.length) {
              <smartFormLogic-card
                [questions]="questionsInUse"
                [thisCategoryId]="category.id"
                [rootCondition]="getRootConditionById(conditionId)"
                (onClickEdit)="
                  OpenConditionalLogic(getRootConditionById(conditionId))
                "
                (click)="stopPropagation($event)"
              ></smartFormLogic-card>
              }
            </div>
            }
          </div>
          }
        </div>
        <div class="flex-right">
          {{category?.smartFormSubCategories?.length ?? 0}}
          {{
            category?.smartFormSubCategories?.length == 1
              ? ("smartForms.subcategory" | transloco)
              : ("smartForms.subcategories" | transloco)
          }}
        </div>
        <div class="count-circle">
          <div class="count">{{ countQuestionsInCategory(category) }}</div>
        </div>
        @if (!isProductionMode) {
        <i class="big th icon" #categoryDragHandle></i>
        }
        <div class="floating-options" (click)="$event.stopPropagation()">
          @if (!isProductionMode) {
          <i class="pen icon" (click)="onClickEditCategory(category, i)"></i>
          } @if (!lockStatus && !isProductionMode) {
          <i class="trash icon" (click)="showDeleteModal('category', [i])"></i>
          }
        </div>
      </div>
      @if (!category.collapsed) {
      <span
        class="card-body drag-boundary"
        #subCategoryBounds
        [ngClass]="{
          'top-b': true,
          'bottom-b': true,
          'left-b': true,
          'right-b': true
        }"
      >
        <div class="add-subcategory flex">
          @if (!isProductionMode) {
          <div class="ui button" (click)="showCreateSubCategoryModal(i)">
            <i class="plus circle icon"></i>
            {{ "smartForms.Add-subcategory" | transloco }}
          </div>
          }
        </div>
        @for (subCategory of category?.smartFormSubCategories; track
        subCategory; let j = $index) {
        <div
          class="subCategory"
          [reOrderableList]="category.smartFormSubCategories"
          (moveUp)="swapItemsInList(category.smartFormSubCategories, j, j - 1)"
          (moveDown)="
            swapItemsInList(category.smartFormSubCategories, j, j + 1)
          "
          droppable
          [dropScope]="isDropAllowed(subCategory)"
          dragHintClass="dropZone"
          dragOverClass="hover-dropZone"
          (onDrop)="addQuestion($event.dragData, subCategory)"
          ngDraggable
          [handle]="subCatDragHandle"
          [preventDefaultEvent]="true"
          [zIndexMoving]="9999"
          [trackPosition]="false"
          lockAxis="x"
          [bounds]="subCategoryBounds"
          [inBounds]="true"
        >
          <div class="flex subCategory-Header">
            <h4 style="margin: 0px;">
              {{ subCategory.id ? subCategory.id : "" }}. {{ subCategory.name }}
            </h4>
            <div
              class="condition-count"
              (mouseenter)="subCategory.hoverConditions = true"
              (mouseleave)="subCategory.hoverConditions = false"
            >
              {{ subCategory.conditionIds?.length || 0 }}
              {{
                subCategory.conditionIds?.length != 1
                  ? ("smartForms.conditions" | transloco)
                  : ("smartForms.condition" | transloco)
              }}
              @if (subCategory.hoverConditions &&
              subCategory.conditionIds?.length) {
              <div class="popup-content" style="left: 175%">
                @for (conditionId of subCategory.conditionIds; track
                conditionId; let first = $first) {
                <div>
                  @if (!first) {
                  <hr />
                  } @if (questionsInUse?.length) {
                  <smartFormLogic-card
                    [questions]="questionsInUse"
                    [thisCategoryId]="category.id"
                    [thisSubCategoryId]="subCategory.id"
                    [rootCondition]="getRootConditionById(conditionId)"
                    (onClickEdit)="
                      OpenConditionalLogic(getRootConditionById(conditionId))
                    "
                    (click)="stopPropagation($event)"
                  ></smartFormLogic-card>
                  }
                </div>
                }
              </div>
              }
            </div>
            <div class="count-circle flex-right">
              <div class="count">
                {{ countQuestionsInSubCategory(subCategory) }}
              </div>
            </div>
            @if (!isProductionMode) {
            <i #subCatDragHandle class="big th icon"></i>
            }
            <div class="floating-options" (click)="$event.stopPropagation()">
              @if (!isProductionMode) {
              <i
                class="pen icon"
                (click)="onClickEditSubCategory(subCategory, i, j)"
              ></i>
              } @if (!lockStatus && !isProductionMode) {
              <i
                class="trash icon"
                (click)="showDeleteModal('subCategory', [i, j])"
              ></i>
              }
            </div>
          </div>
          @if (subCategory.smartFormQuestions?.length > 0) {
          <div
            #questionBounds
            [ngClass]="{
              'top-b': true,
              'bottom-b': true,
              'left-b': true,
              'right-b': true
            }"
          >
            @for (question of subCategory?.smartFormQuestions; track question;
            let k = $index) {
            <div
              class="question-list"
              [reOrderableList]="subCategory.smartFormQuestions"
              (moveUp)="
                swapItemsInList(subCategory.smartFormQuestions, k, k - 1)
              "
              (moveDown)="
                swapItemsInList(subCategory.smartFormQuestions, k, k + 1)
              "
              ngDraggable
              [handle]="questionDragHandle"
              [preventDefaultEvent]="true"
              [zIndexMoving]="9999"
              [trackPosition]="false"
              lockAxis="x"
              [bounds]="questionBounds"
              [inBounds]="true"
              draggable
              [dragScope]="'question'"
              [dragData]="generateDragData(question, true, category)"
              (mouseover)="onDragStart(question, true, category)"
            >
              <div
                class="flex question"
                (click)="
                  question.children
                    ? (question.collapsed = !question.collapsed)
                    : ''
                "
              >
                <div class="flex" style="align-items: start;">
                  <div
                    style="display: flex; flex-direction: column;"
                    [style]="question.children ? 'cursor: pointer;' : ''"
                  >
                    @if (showQuestionId) {
                    <b>{{ question.questionId }}.</b>
                    } @if (question.children?.length) {
                    <i
                      class="chevron icon"
                      style="cursor: pointer; font-size: larger;"
                      [ngClass]="{
                        up: question?.collapsed,
                        down: !question?.collapsed
                      }"
                    ></i>
                    }
                  </div>
                  <div>
                    <b>{{ question?.question }}</b>
                    <div>{{ question?.displayFieldType }}</div>
                  </div>
                </div>
                <div></div>
                <div class="condition-count"></div>
                <div
                  class="condition-count"
                  (mouseenter)="question.hoverConditions = true"
                  (mouseleave)="question.hoverConditions = false"
                >
                  {{ question.conditionIds?.length || 0 }}
                  {{
                    question.conditionIds?.length != 1
                      ? ("smartForms.conditions" | transloco)
                      : ("smartForms.condition" | transloco)
                  }}
                  @if (question.hoverConditions &&
                  question.conditionIds?.length) {
                  <div class="popup-content">
                    @for (conditionId of question.conditionIds; track
                    conditionId; let first = $first) {
                    <div>
                      @if (!first) {
                      <hr />
                      } @if (questionsInUse?.length) {
                      <smartFormLogic-card
                        [questions]="questionsInUse"
                        [thisCategoryId]="category.id"
                        [thisSubCategoryId]="subCategory.id"
                        [thisQuestionId]="question.questionId"
                        [rootCondition]="getRootConditionById(conditionId)"
                        (onClickEdit)="
                          OpenConditionalLogic(
                            getRootConditionById(conditionId)
                          )
                        "
                        (click)="stopPropagation($event)"
                      ></smartFormLogic-card>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
                @if (!isProductionMode) {
                <div
                  [attr.data-test-ref]="'ellipsis'"
                  [matMenuTriggerFor]="popupTemplate"
                  class="icon blue-ellipsis flex-right"
                  (click)="stopPropagation($event)"
                ></div>
                }
                <mat-menu #popupTemplate yPosition="above">
                  <div
                    class="flex-v"
                    style="align-items: flex-end"
                    [ngClass]="{ wide: canDeleteData, default: !canDeleteData }"
                  >
                    <label class="noMargin flex flex-right" style="gap: 0.5rem">
                      <p class="noMargin">
                        {{ "smartForms.Show-by-default" | transloco }}:
                      </p>
                      <input
                        type="checkbox"
                        style="width: 20px; height: 20px;"
                        [(ngModel)]="question.showByDefault"
                      />
                      <!-- <span class="slider"></span> -->
                    </label>
                    <label class="noMargin flex flex-right" style="gap: 0.5rem">
                      <p class="noMargin">
                        {{ "smartForms.Hide-for-preparer" | transloco }}:
                      </p>
                      <input
                        type="checkbox"
                        style="width: 20px; height: 20px;"
                        [(ngModel)]="question.hideForPreparer"
                      />
                      <!-- <span class="slider"></span> -->
                    </label>
                    <label class="noMargin flex flex-right" style="gap: 0.5rem">
                      <p class="noMargin">
                        {{ "smartForms.Trigger-sync-in-OneTeam" | transloco }}:
                      </p>
                      <input
                        type="checkbox"
                        style="width: 20px; height: 20px;"
                        [(ngModel)]="question.triggerSyncInOneTeam"
                      />
                      <!-- <span class="slider"></span> -->
                    </label>
                  </div>
                </mat-menu>
                @if (!isProductionMode) {
                <i #questionDragHandle class="big th icon"></i>
                }
                <div
                  class="floating-options"
                  (click)="$event.stopPropagation()"
                >
                  @if (!lockStatus && !isProductionMode) {
                  <i
                    class="trash icon"
                    (click)="showDeleteModal('question', [i, j, k])"
                  ></i>
                  }
                </div>
              </div>
              @for (childQuestion of question.collapsed ? question?.children :
              []; track childQuestion) {
              <div
                class="question flex"
                style="margin-bottom: 0.5rem; margin-top: 0.5rem; margin-left: 3rem; background-color: rgb(200, 200, 200);"
              >
                <div class="flex" style="align-items: start;">
                  @if (showQuestionId) {
                  <b>{{ childQuestion.id }}.</b>
                  }
                  <div>
                    <b>{{childQuestion?.question ?? 'question'}}</b>
                    <div>{{childQuestion?.category ?? 'category'}}</div>
                  </div>
                </div>
                <div class="flex-right">
                  {{childQuestion?.displayFieldType ?? 'Text'}}
                </div>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </span>
      }
    </div>
    }
  </div>
</div>
} @if (isLoading) {
<div class="ui active inverted dimmer" [ngClass]="{ dimmed: !firstLoad }">
  <div class="ui large text loader">{{ "smartForms.loading" | transloco }}</div>
</div>
} @if (isSaving) {
<div class="ui active inverted dimmer" [ngClass]="{ dimmed: !firstLoad }">
  <div class="ui large text loader">{{ "smartForms.saving" | transloco }}</div>
</div>
}

<!-- <div *ngIf="!isReady" class="ui active inverted dimmer">
<div class="ui large loader"></div>
</div> -->

<!-------------------- MODALS -------------------->
<div id="modals-container">
  <div #editLogicModal class="ui modal">
    @if (openModal == 'logic') {
    <app-smart-form-logic-editor
      [existingLogicNode]="rootNodeBeingEdited"
      [smartFormCategories]="categories"
      (onSave)="updateRootLogicNode($event)"
      (onDelete)="deleteRootLogicNode(rootNodeBeingEdited) + hideLogicModal()"
      (onCancel)="hideLogicModal()"
    >
    </app-smart-form-logic-editor>
    }
  </div>

  <div #newCategoryModal id="new-category-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <h1>{{ "settings.create-new-category" | transloco }}</h1>

    <form (ngSubmit)="upsertedItem.name?.length && createCategory()">
      <div>
        <label>{{ "settings.category-name" | transloco }}</label>
        <input type="text" [(ngModel)]="upsertedItem.name" name="name" />
      </div>

      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !upsertedItem.name?.length }"
        >
          {{ "settings.create" | transloco }}
        </button>
      </div>
    </form>
  </div>

  <div #newSubCategoryModal id="new-subcategory-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    @if (upsertedItem?.categoryIndex !== null) {
    <form (ngSubmit)="upsertedItem.name?.length && createSubCategory()">
      <div>
        <label>{{ "settings.subcategory-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="upsertedItem.name"
          name="newSubcategoryName"
        />
      </div>
      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !upsertedItem.name?.length }"
        >
          {{ "settings.create" | transloco }}
        </button>
      </div>
    </form>
    }
  </div>

  <div #editModal id="edit-modal" class="ui tiny modal edit">
    <div class="icon modal-close close"></div>

    <h1>
      {{
        upsertedItem.subCategoryIndex !== ""
          ? ("settings.edit-subcategory" | transloco)
          : ("settings.edit-category" | transloco)
      }}
    </h1>

    <form (ngSubmit)="upsertedItem.name?.length && updateItem()">
      <div>
        <label>{{
          upsertedItem.subCategoryIndex !== ""
            ? ("settings.subcategory-name" | transloco)
            : ("settings.category-name" | transloco)
        }}</label>
        <input type="text" [(ngModel)]="upsertedItem.name" name="name" />
      </div>

      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !upsertedItem.name?.length }"
        >
          {{ "settings.edit" | transloco }}
        </button>
      </div>
    </form>
  </div>

  <div #confirmDeleteModal id="confirm-delete-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <div class="content">
      <h3>{{ "settings.are-you-sure-you-want-to-remove-this" | transloco }}</h3>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
      <div class="ui primary background approve button" (click)="deleteItem()">
        {{ "settings.yes-remove" | transloco }} {{ deletingType }}
      </div>
    </div>
  </div>

  <div #msgModal id="success-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <div class="content">
      <div class="icon" [ngClass]="{ 'red-error': deletionErrorMessage }"></div>

      <h3>Failed to delete {{ this.deletingType }}</h3>

      <p>{{ deletionErrorMessage }}</p>
    </div>

    <div class="actions">
      <div class="ui primary background button approve">
        {{ "settings.ok" | transloco }}
      </div>
    </div>
  </div>

  <div #oneteamSyncModal class="ui modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "settings.Sync-Smart-Form-to-OneTeam" | transloco }}</h1>
    <div>
      <div class="oneteam-sync">
        {{
          oneteamSyncResponse?.success
            ? ("settings.Successfully-synced-smart-form-with-OneTeam"
              | transloco)
            : oneteamSyncResponse.message
        }}
      </div>
    </div>
    <div class="oneteam-sync">
      <button
        class="ui primary button background tiny"
        (click)="closeOneteamSyncModal()"
      >
        {{ "clients.Close" | transloco }}
      </button>
    </div>
  </div>
</div>
